export function Brand({ compact = false }: { compact?: boolean }) {
  return <div className={`brand ${compact ? 'brand--compact' : ''}`} aria-label="HILTAC Asistencias">
    <span className="brand__mark">H</span>
    <span><strong>HILTAC</strong><small>ASISTENCIAS</small></span>
  </div>
}
